import React from "react"
import Components from "../index"
import { blokType } from "../../types"
import {
  StyledModalSectionOuter,
  StyledModalSection,
  StyledModalSectionLabel,
  StyledModalSectionTitle,
  StyledModalSectionContent,
  StyledSectionBackgroundImage,
} from "./partials"

export interface ModalSectionProps {
  id: string
  blok: {
    _uid: string
    title: string
    section_title: string
    // anchor: string,
    content: blokType[]
    background_image: blokType[]
  }
  accent_color: string
}

export const S22ModalSection: React.FC<ModalSectionProps> = ({
  id,
  blok,
  accent_color,
}) => {
  return (
    <StyledModalSectionOuter>
      {blok.background_image && blok.background_image.length > 0 && (
        <StyledSectionBackgroundImage
          background_image={blok.background_image[0].media.filename}
        />
      )}
      <StyledModalSection id={id}>
        {blok.title && (
          <StyledModalSectionLabel accent_color={accent_color}>
            {blok.title}
          </StyledModalSectionLabel>
        )}
        {blok.section_title && (
          <StyledModalSectionTitle>
            {blok.section_title}
          </StyledModalSectionTitle>
        )}
        {blok.content && blok.content.length > 0 && (
          <StyledModalSectionContent>
            {blok.content.map((content: blokType) =>
              React.createElement(Components(content.component), {
                key: content._uid,
                blok: content,
              })
            )}
          </StyledModalSectionContent>
        )}
      </StyledModalSection>
    </StyledModalSectionOuter>
  )
}
